// extracted by mini-css-extract-plugin
module.exports = {"mediumScreen":"992px","smallScreen":"540px","category-list":"CategoryList_category-list__Ycz_2","category":"CategoryList_category__3HEEs"};